import React, { lazy, Suspense, useCallback, useMemo, useState } from "react";
import * as urls from "../../utils/URLConst";
import makeRequest from "../../utils/makeRequest";
import OurServicesModal from "../../componants/modal/DashboardCard/OurServicesModal";
import { useDispatch } from "react-redux";
import { handleLoader } from "../../redux/reducers/layout";
import { Card, Col, Row } from "react-bootstrap";
import toastNotify from "../../utils/ToastNotify";
import Loader from "../../componants/loader/Loader";
import { BiFileBlank, BiLayerPlus, BiLoader, BiSlider, BiUser } from "react-icons/bi";

const ProductServiceTbl = lazy(() => import('../../contants/tables/ProductServiceDltTbl'));
const Representative = lazy(() => import('./Representative'));
const Documents = lazy(() => import('./Documents'));
const SwiperCarsouel = lazy(() => import('../../componants/swipercarsouel/SwiperCarsouel'));

const Dashboard = () => {
  const [serviceCount, setServiceCount] = useState([]);
  const [productList, setProductList] = useState({});
  const [clientDocuments, setClientDocuments] = useState([]);
  const [agentDetail, setAgentDetail] = useState([]);
  const [apidata, setApiData] = useState([]);
  const [ourServicesModal, setOurServicesModal] = useState(false);
  const dispatch = useDispatch();

  const openOurServicesModal = () => {
    setOurServicesModal(true);
  };

  const getProductcategories = useCallback(async () => {
    try {
      dispatch(handleLoader(true));
      const data = {
        FLAG: "Y",
      };
      const result = await makeRequest(
        "POST",
        urls.getProductCategory,
        data,
        {}
      );
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setServiceCount(response);
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }, [])

  const fetchProductList = useCallback(async (value, id) => {
    try {
      dispatch(handleLoader(true));

      const data = {
        FLAG: "",
        CAT_CD: value.CAT_CD,
      };
      const result = await makeRequest(
        "POST",
        urls.getDashboardProductList,
        data,
        {}
      );
      if (result.STATUS === "0") {
        openOurServicesModal(true);
        const response = result.RESPONSE;
        setProductList({
          category_name: value.CAT_NM,
          usedProduct: value.PRODUCT_USED,
          notUsedProduct: value.PRODUCT_COUNT,
          Icon: value.ICON,
          productUsed: value.PRODUCT_USED,
          productCount: value.PRODUCT_COUNT,
          data: response,
        });
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // ignore Case
    }
    finally {
      dispatch(handleLoader(false));
    }
  }, [])

  const fetchProdcuServiceTable = useCallback(async () => {
    try {
      dispatch(handleLoader(true));
      const data = {
        FLAG: "A",
      };
      const result = await makeRequest(
        "POST",
        urls.getProductServiceTable,
        data,
        {}
      );
      if (result.STATUS === "0") {
        const response = result.RESPONSE;

        const sortedData = response.sort((a, b) => {
          if (a.EXPIRING_FLAG === 'Y' && b.EXPIRING_FLAG !== 'Y') return -1;
          if (a.EXPIRING_FLAG !== 'Y' && b.EXPIRING_FLAG === 'Y') return 1;
          return 0;
        });

        setApiData(sortedData);
      } else {
        result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ignore
    } finally {
      dispatch(handleLoader(false));
    }
  }, [])

  const fetchClientDocuments = useCallback(async () => {
    try {
      dispatch(handleLoader(true));
      const result = await makeRequest("POST", urls.getClientDocuments, {}, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setClientDocuments(response);
      } else {
        result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  })

  const fetchAgentDtl = useCallback(async () => {
    try {
      dispatch(handleLoader(true));
      const result = await makeRequest("POST", urls.getClientDtl, {}, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setAgentDetail(response);
      } else if (result.STATUS !== "0") {
        result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  })

  useMemo(() => {
    (async () => {
      await getProductcategories();
      await fetchProdcuServiceTable();
      await fetchAgentDtl();
      await fetchClientDocuments();
    })();
  }, []);

  const [loadedCount, setLoadedCount] = useState(0);

  const handleImageLoad = () => {
    setLoadedCount((prev) => prev + 1);
  };


  return (
    <>
      <div className="container-xxl flex-grow-1 container-margin container-p-y">
        {/* **************  Welcome and Login detail ************** */}
        <div className="row dashboard-top"></div>
        {/* **************  New card desigin - with Nach product and other new ************** */}
        <Row>
          {serviceCount.slice(0, loadedCount + 1).map((value, index) => (
            <Col md={3} key={index} className={index > 0 ? "mt-md-0 mt-3" : ""}>
              <Card>
                <Card.Body className="p-3">
                  <div
                    className="d-flex align-items-center gap-2"
                  >
                    <div style={{ color: "#ccc" }}>
                      <img
                        src={value.ICON}
                        alt=""
                        width={50}
                        height={50}
                        onLoad={handleImageLoad}
                      />
                    </div>

                    <div>
                      <div
                        className="fw-semibold outstanding-amount-text"
                        onClick={() => {
                          fetchProductList(value, index);
                        }}
                      >
                        {value.CAT_NM}
                      </div>
                      <div className="text-sm text-primary">
                        Currently uses : {value.PRODUCT_USED} out of{" "}{value.PRODUCT_COUNT}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}

          {/* **************  Product and Services Table ************** */}
          <Col md={8} className="mt-3">
            <div className="pb-2 fw-semibold">
              <BiLayerPlus className="text-lg" />
              <span className="ps-2">Products & Services</span>
            </div>
            <Card>
              <Card.Body>
                <Suspense fallback={<Loader isLoader={true} />}>
                  <ProductServiceTbl
                    data={apidata}
                    flag="D"
                    isHeaderFixed
                  />
                </Suspense>
              </Card.Body>
            </Card>
          </Col>

          {/* **************  Our Representative Card ************** */}
          <Col md={4} className="mt-3">
            <div className="pb-2 fw-semibold">
              <BiUser className="text-lg" />
              <span className="ps-2">Our Representative</span>
            </div>

            <Card>
              <Card.Body className="p-0">
                <Suspense fallback={<Loader isLoader={true} />}>
                  {agentDetail.length > 0 ?
                    <Representative data={agentDetail} />
                    :
                    <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: 395 }}>
                      <div >
                        <img
                          src="./assets/images/No-data.jpg"
                          alt=""
                          style={{ width: 200 }}
                        />
                        <h4 className="mt-3 text-sm text-center"> No Representative Assigned </h4>
                      </div>
                    </div>
                  }
                </Suspense>
              </Card.Body>
            </Card>
          </Col>

          {/* **************  Document Card ************** */}
          <Col md={8} className="mt-3">
            <div className="pb-2 fw-semibold">
              <BiFileBlank className="text-lg" />
              <span className="ps-2">Document</span>
            </div>

            <Card
              style={{
                height: "400px",
              }}
            >
              <Card.Body className="p-0">
                <Suspense fallback={<Loader isLoader={true} />}>
                  <Documents data={clientDocuments} />
                </Suspense>
              </Card.Body>
            </Card>
          </Col>

          {/* **************  Other Products/Services Card ************** */}
          <Col md={4} className="swiperMargin mt-3">
            <div className="pb-2 fw-semibold">
              <BiSlider className="text-lg" />
              <span className="ps-2">Other Products & Services</span>
            </div>
            <Card>
              <Card.Body
                className="py-0"
                style={{
                  height: "400px",
                  overflowY: "scroll",
                }}
              >
                <Suspense fallback={<Loader isLoader={true} />}>
                  <SwiperCarsouel />
                </Suspense>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div >

      {ourServicesModal && (
        <OurServicesModal
          ourServicesModal={ourServicesModal}
          setOurServicesModal={setOurServicesModal}
          productList={productList}
        />
      )}
    </>
  );
};

export default Dashboard;
